import Actions from '@wix/calendar-client-library-v3/dist/src/enums/ActionsEnum';
import { get } from 'lodash';
import { addBiEventLiveSite } from '../../widdgetUtils/biEventsHandlers';

const openMobilePopup = (data, state, setState) => {
  const IS_DEV = (process.env.NODE_ENV as string) === 'development';
  const domain = !IS_DEV
    ? 'https://editor.wix.com/wix-labs/google-calendar/popupApp'
    : 'https://localhost:3001/popupApp';

  const {
    isAgenda,
    isMonthly,
    isWeekly,
    action,
    timezone,
    locale,
    isTimeZoneShown,
    weekStarter,
    datePickerMobileDate,
  } = state;

  addBiEventLiveSite('expand_event', isAgenda, isWeekly, isMonthly);

  const position = {
    origin: window.Wix.WindowOrigin.FIXED,
    placement: window.Wix.WindowPlacement.BOTTOM_CENTER,
    x: 0,
    y: 0,
  };

  const isMenu = data.popup === 'MANU' || false;
  const isEvent = data.popup === 'EVENT' || false;
  const isDatePicker = data.popup === 'DATE_PICKER' || false;

  const expandedData = '';

  const onCloseMenuHandler = ({ message }) => {
    if (message) {
      if (message.action === Actions.TODAY) {
        addBiEventLiveSite('today_button', isAgenda, isWeekly, isMonthly);
      }
      setState((state) => ({
        ...state,
        action: get(message, 'action', action),
        timezone: get(message, 'tz', timezone),
      }));
    }
  };

  const onPickerCloseHandler = ({ message }) => {
    if (message) {
      setState((state) => ({
        ...state,
        datePickerMobileDate: get(message, 'date', datePickerMobileDate),
      }));
    }
  };

  if (isMenu) {
    const isEnterClicked = data.isEnterClicked;

    const POPUP_URL = `${domain}?isMenu=${isMenu}&isEvent=${isEvent}&isDatePicker=${isDatePicker}&localeParam=${locale}&timezone=${timezone}&isAgenda=${isAgenda}&isWeekly=${isWeekly}&isMonthly=${isMonthly}&isEnterClicked=${isEnterClicked}&isTimeZoneShown=${isTimeZoneShown}`;

    window.Wix &&
      window.Wix.openPopup(
        POPUP_URL,
        '100%',
        '100%',
        position,
        onCloseMenuHandler,
        window.Wix.Theme.BARE,
      );
  }

  if (isEvent) {
    // const { recurringEventId } = data.expandedData;
    const isCloseFocused = data.isCloseFocused;
    // if (
    //   recurringEventId !== '' &&
    //   recurringEventId !== null &&
    //   typeof recurringEventId !== 'undefined'
    // ) {
    //   expandedData = `${JSON.stringify(data.expandedData)}`;
    // }
    const expandedEventsProps = JSON.parse(
      JSON.stringify(data.expandedEventsProps),
    );
    window.localStorage.removeItem('copyLink');
    window.localStorage.removeItem('title');
    window.localStorage.removeItem('summary');
    window.localStorage.removeItem('location');
    window.localStorage.removeItem('eventExpandData');

    window.localStorage.setItem('copyLink', data.expandedEventsProps.copyLink);
    window.localStorage.setItem('title', data.expandedEventsProps.title);
    window.localStorage.setItem('summary', data.expandedEventsProps.summary);
    window.localStorage.setItem('location', data.expandedEventsProps.location);

    expandedEventsProps.copyLink = '';
    expandedEventsProps.title = '';
    expandedEventsProps.summary = '';
    expandedEventsProps.location = '';

    const eventExpandData = `${JSON.stringify(expandedEventsProps)}`;
    window.localStorage.setItem('eventExpandData', eventExpandData);

    const POPUP_URL = `${domain}?isMenu=${isMenu}&isEvent=${isEvent}&isDatePicker=${isDatePicker}&expandedData=${expandedData}&localeParam=${locale}&timezone=${timezone}&isAgenda=${isAgenda}&isWeekly=${isWeekly}&isMonthly=${isMonthly}&isCloseFocused=${isCloseFocused}`;

    window.Wix &&
      window.Wix.openPopup(
        POPUP_URL,
        '100%',
        !IS_DEV ? '100%' : `${document.documentElement.scrollHeight * 0.65}px`,
        position,
        () => console.log('close'),
        window.Wix.Theme.BARE,
      );
  }

  if (isDatePicker) {
    const POPUP_URL = `${domain}?isMenu=${isMenu}&isEvent=${isEvent}&isDatePicker=${isDatePicker}&expandedData=${expandedData}&localeParam=${locale}&weekStarter=${weekStarter}`;

    window.Wix &&
      window.Wix.openPopup(
        POPUP_URL,
        '100%',
        '100%',
        position,
        onPickerCloseHandler,
        window.Wix.Theme.BARE,
      );
  }
};

export default openMobilePopup;
